<template>
  <div class="x-audio-wrap" :class="{inline:!block}" ref="wrap" @click="play">
    <div class="x-sector" :class="{play:animate}">
      <div class="x-dot"></div>
    </div>
    <div class="x-time">{{duration&&showDuration?duration:text}}</div>
  </div>
</template>
<script>
  export default {
    name:'m-audio',
    props:{
      src:{
        type:String,
        default:''
      },
      text:{
        type:String,
        default:"轻触播放"
      },
      showDuration:{
        type:Boolean,
        default:true
      },
      block:{
        type:Boolean,
        default:true
      },
    },
    data(){
      return{
        audio:null,
        animate:false,
        timer:null,
        duration:null
      }
    },
    updated( ){

    },
    watch: {
      src(val) {
        console.log('------>',val)
        this.audio && this.audio.pause()
        this.audio=new Audio()
        this.audio.src=this.src
        this.audio.addEventListener('canplaythrough',()=>{
          this.duration=this.format(this.audio.duration)
        })
        this.audio.onplay=()=>{
          this.animate=true
          this.timer=setInterval(() => {
            this.animate=false
            setTimeout(()=>{
              this.animate=true
            },100)
          }, 1250);
        }
        this.audio.onpause=()=>{
          this.animate=false
          this.timer&&clearInterval( this.timer)
          this.audio.currentTime = 0

        }
        this.audio.onstop =()=>{
          this.animate=false
          this.timer&&clearInterval( this.timer)
        }
        this.audio.onended=()=>{
          this.animate=false
          this.timer&&clearInterval( this.timer)
        }
        window.audioList.push(this.audio)//所有实例加入全局变量
      }
    },
    mounted(){
      this.audio=new Audio()
      this.audio.src=this.src
      this.audio.addEventListener('canplaythrough',()=>{
        this.duration=this.format(this.audio.duration)
      })
      this.audio.onplay=()=>{
        this.animate=true
        this.timer=setInterval(() => {
          this.animate=false
          setTimeout(()=>{
            this.animate=true
          },100)
        }, 1250);
      }
      this.audio.onpause=()=>{
        this.animate=false
        this.timer&&clearInterval( this.timer)
        this.audio.currentTime = 0

      }
      this.audio.onstop =()=>{
        this.animate=false
        this.timer&&clearInterval( this.timer)
      }
      this.audio.onended=()=>{
        this.animate=false
        this.timer&&clearInterval( this.timer)
      }
      window.audioList.push(this.audio)//所有实例加入全局变量
    },
    deactivated(){
      this.audio && this.audio.pause()
    },
    methods:{
      play(){

        window.audioList.forEach(audio=>{//开始前先关闭所有可能正在运行的实例
          audio.pause()
        })
        // audio.currentTime
        // this,audio.paused
        if(this.audio.currentTime === 0){
          this.audio.play()
        }else{

          this.audio.pause()
        }
      },
      format(s){
        var t='';
        if(s > -1){
          var min = Math.floor(s/60) % 60;
          var sec = s % 60;
          if(min < 10){t += "0";}
          t += min + "'";
          if(sec < 10){t += "0";}
          t += sec.toFixed(2);
        }
        t=t.replace('.','\"')
        return t;
      },
    }


  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .x-audio-wrap{
    height: 40px;
    border-radius: 10px;
    // border: 1px solid #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    background-color #28c75c
    .x-sector{
      height: 6px;
      width: 6px;
      border-radius:4px 8px;
      border-right: 2px solid #fff;
      border-top: 2px solid #fff;
      transform: rotate(45deg);
      position: relative;
      margin-left: 10px;
      .x-dot{
        height: 4px;
        width: 4px;
        border-radius: 4px;
        background: #fff;
        position: absolute;
        top: 2px;
      }
    }
    .x-sector::before{
      content: "";
      height: 10px;
      width: 10px;
      border-radius:4px 12px;
      border-right: 2px solid #fff;
      border-top: 2px solid #fff;
      transform: rotate(0deg);
      position: absolute;
      right: -7px;
      top: -7px;
    }
    .x-sector::after{
      content: "";
      height: 14px;
      width: 14px;
      border-radius:2px 12px;
      border-right: 2px solid #fff;
      border-top: 2px solid #fff;
      transform: rotate(0deg);
      position: absolute;
      right: -12px;
      top: -12px;
    }

    .x-time{
      color: #fff;
      font-size: 12px;
      margin-right: 10px;
    }
    &.inline{
      display: inline-flex
    }
  }
  @keyframes play-dot{
    from{
      background: #fff
    }
    to{
      background: #28c75c
    }
  }
  @keyframes play-sector{
    from{
      border-color: #fff
    }
    to{
      border-color: #70c795
    }
  }
  .x-sector.play{
    animation: play-sector 0.3s 0.1s ease-in-out;
  }
  .x-sector.play::before{
    animation: play-sector 0.3s 0.2s ease-in-out;
  }
  .x-sector.play::after{
    animation: play-sector 0.3s 0.3s ease-in-out;
  }
  .x-sector.play .x-dot{
    animation: play-dot 0.3s ease-in-out;
  }
</style>



// WEBPACK FOOTER //
// app/components/audio/audio.vue